import * as React from 'react';
import { Helmet } from 'react-helmet';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import NoEncryptionIcon from '@mui/icons-material/NoEncryption';
import CampaignIcon from '@mui/icons-material/Campaign';
import ApartmentIcon from '@mui/icons-material/Apartment';
import HouseIcon from '@mui/icons-material/House';
import PersonIcon from '@mui/icons-material/Person';
import { useStoreActions, useStoreState } from 'easy-peasy';
import LocationOnIcon from '../images/location.png';
import PasswordIcon from '../images/password.png';
import EmailIcon from '../images/email.png';
import PassIcon from '../images/shield.png';
import UserIcon from '../images/design_useroutlined.png';
import PhoneIcon from '../images/phone.png';
import StreetIcon from '../images/street.png';
import CityIcon from '../images/citi.png';
import HornIcon from '../images/horn.png';
import PlusIcon from '../images/plus.png';
import MinusIcon from '../images/minus.png';
import { Post, PostAuthorized, GetAthourized } from '../services/http';
import { validateForm } from '../services/validate';
import UploadImage from '../services/upload-image';
import { BanquestCreditCard } from '../components/payments/banquest-credit-card';
import TermsPopup from '../dialogs/terms-popup';

export default function SignUpCamapaingPage() {
    const [certificateState, setSertificateState] = React.useState(null);
    const [subscriptionID, setSubscriptionID] = React.useState(null);
    const [userInfo, setUserInfo] = React.useState(null);
    const [rabbanim, setRabbanim] = React.useState([{ address: '', phone: '', name: '' }]);
    const [userID, setUserID] = React.useState(null);
    const [amount, setAmount] = React.useState(28);
    const [returnUrl, setReturnUrl] = React.useState(null);
    const [attachFile, setAttachFile] = React.useState(null);
    const [isFormTouched, setIsFormTouched] = React.useState(false);
    const [iDPhoto, setIDPhoto] = React.useState(null);
    const [userExists, setUserExists] = React.useState(false);
    const [openVaadAgree, setOpenVaadAgree] = React.useState(false);
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const config = useStoreState((state) => state.config);
    const [openTermsPopup, setOpenTermsPopup] = React.useState(null);

    const showTermsPopup = (value) => {
        setOpenTermsPopup(value);
    };

    const showVaadAgree = (vaadAgreeNewCertificateState) => {
        if (vaadAgreeNewCertificateState) {
            const vaadAgreeEl = document.getElementById('vaad-hatzedaka-payment');
            if (vaadAgreeEl) {
                vaadAgreeEl.checked = false;
            }
            setOpenVaadAgree(false);
        } else {
            setOpenVaadAgree(true);
        }
    };
    const updateCertificateState = (newSertificateState) => {
        setSertificateState(newSertificateState);
        showVaadAgree(newSertificateState);
    };
    const showRabbanimValues = (rabbanimList) => {
        rabbanimList.forEach((item, index) => {
            document.getElementById('rabbanim-address-' + index).value = item.address;
            document.getElementById('rabbanim-phone-' + index).value = item.phone;
            document.getElementById('rabbanim-name-' + index).value = item.name;
        });
    };

    const logout = () => {
        localStorage.removeItem('token');
        window.location.reload();
    };

    const showExistingUserNotice = () => {
        if (userExists) {
            openInfoPopup({
                notice: 'User with this email is already created you can update details by chaning the fields, If you need to change email, please click on "Logout" button',
                btnName: 'CLOSE',
                isLogOutBtn: true
            });
        }
    };

    const showHazdakaCertificateValue = (certValue) => {
        switch (certValue) {
            case (true):
                document.getElementById('certificate-state-true').checked = true;
                break;
            case (false):
                document.getElementById('certificate-state-false').checked = true;
                break;
            default:
                return;
        }
    };

    const getUserDetails = async () => {
        // אם יש משתמש אז להדביק פרטים שלו בתוך הטופס
        // localStorage.setItem('token', '');
        console.log('token', localStorage.getItem('token'));
        if (localStorage.getItem('token') !== null && localStorage.getItem('token') !== '') {
            setUserExists(true);
            const result = await GetAthourized('/api/donation/GetUser', {});
            console.log('Get user result', result);
            if (result.result) {
                setUserInfo(result.data);
                const rabbanimValuesObject = JSON.parse(result?.data?.rabbanim);
                console.log('rabbanimValuesObject', rabbanimValuesObject);
                setRabbanim(rabbanimValuesObject);
                if (result.data.vaadHatzedakaPaymentStatus === 'agree' || result.data.vaadHatzedakaPaymentStatus === 'paid') {
                    setOpenVaadAgree(true);
                    document.getElementById('vaad-hatzedaka-payment').checked = true;
                }
                setTimeout(() => {
                    showRabbanimValues(rabbanimValuesObject);
                }, 2000);
                // setRabbanim(result.data.isHatzedakaCertificate);  
                setSertificateState(result.data.isHatzedakaCertificate);
                console.log('result.data.isHatzedakaCertificate', result.data.isHatzedakaCertificate);
                showHazdakaCertificateValue(result.data.isHatzedakaCertificate);
                console.log('result', result.data);
            }
            if (!result.result) {
                localStorage.removeItem('token');
            }
        }
    };

    const addRabanimRow = () => {
        const newRabbanim = [...rabbanim, { address: '', phone: '', name: '' }];
        console.log('newRabbanim', newRabbanim);
        setRabbanim(newRabbanim);
    };
    const subtractRabanimRow = (index) => {
        const newRabbanim = [...rabbanim];
        newRabbanim.splice(index, 1)
        setRabbanim(newRabbanim);
    };


    const setRabbanimValues = (rabbanimList = null) => {
        let newRabbanimList = [];
        rabbanimList = rabbanimList === null ? rabbanim : rabbanimList;
        rabbanimList.forEach((item, index) => {
            newRabbanimList = [...newRabbanimList, {
                address: document.getElementById('rabbanim-address-' + index).value,
                phone: document.getElementById('rabbanim-phone-' + index).value,
                name: document.getElementById('rabbanim-name-' + index).value
            }];
        });
        console.log('our great rabbanim list', newRabbanimList);
        setRabbanim(newRabbanimList);
        return newRabbanimList;
    };

    const updateSubscription = async () => {
        console.log('userExists', userExists);
        const validationFieldsList = userExists ? ['id-photo', 'email', 'first-name', 'last-name', 'phone']
            : ['id-photo', 'email', 'password', 'first-name', 'last-name', 'phone'];
        const validateResult = validateForm(validationFieldsList, null, iDPhoto); // if create don't need to validate form      
        setIsFormTouched(true);
        if (!validateResult.result) {
            const resultReturn = { result: false, notice: validateResult.notice };
            console.log('resultReturn', resultReturn);
            return resultReturn;
        }
        const isAgreeVaadEl2 = document.getElementById('vaad-hatzedaka-payment');
        let totalThankYou = 28;
        if (isAgreeVaadEl2) totalThankYou = isAgreeVaadEl2.checked ? 78 : 28;
        const newReturnUrl2 = config.frontDomain + 'thank-you/subscribe/' + totalThankYou.toString() + '/$';
        console.log('newReturnUrl2', newReturnUrl2);
        console.log('userExists', userExists);
        const newRabbanimList = setRabbanimValues();
        if (userExists) {
            const isAgreeVaadEl3 = document.getElementById('vaad-hatzedaka-payment');
            const isAgreeVaad3 = isAgreeVaadEl3 !== null ? isAgreeVaadEl3.checked : null;
            const resultUser = await PostAuthorized('/api/donation/UpdateSubscribeUser', {
                firstName: document.getElementById('first-name').value,
                secondName: document.getElementById('last-name').value,
                phoneNumber: document.getElementById('phone').value,
                address: document.getElementById('address').value,
                city: document.getElementById('city').value,
                rabbanim: JSON.stringify(newRabbanimList),
                hatzedakaCertificateNumber: certificateState ? document.getElementById('hatzedakaCertificateNumber').value : null,
                isHatzedakaCertificate: certificateState,
                vaadHatzedakaPaymentStatus: isAgreeVaad3 ? 'agree' : null,
                campaignName: document.getElementById('campaignName').value,
                campaignDetails: document.getElementById('campaignDetails').value
            });
            console.log('resultUserupdate', resultUser);
            if (resultUser.result) {
                const resultReturn = { result: true, notice: resultUser.message };
                console.log('resultReturn Update success', resultReturn);
                return resultReturn;
            } else {
                const resultReturn = { result: false, notice: resultUser.message };
                console.log('resultReturn Update error', resultReturn);
                return resultReturn;
            }
        } else {
            const isAgreeVaadEl = document.getElementById('vaad-hatzedaka-payment');
            const isAgreeVaad = isAgreeVaadEl !== null ? isAgreeVaadEl.checked : null;
            const resultUser = await Post('/api/donation/CreateUser', { // זה לא קיים צריך ליצור ב           
                email: document.getElementById('email')?.value,
                password: document.getElementById('password').value,
                firstName: document.getElementById('first-name').value,
                secondName: document.getElementById('last-name').value,
                iDPhoto,
                attachFile,
                source: 'website',
                phoneNumber: document.getElementById('phone').value,
                address: document.getElementById('address').value,
                city: document.getElementById('city').value,
                rabbanim: JSON.stringify(newRabbanimList),
                hatzedakaCertificateNumber: certificateState ? document.getElementById('hatzedakaCertificateNumber').value : null,
                vaadHatzedakaPaymentStatus: isAgreeVaad ? 'agree' : null,
                isHatzedakaCertificate: certificateState,
                campaignName: document.getElementById('campaignName').value,
                campaignDetails: document.getElementById('campaignDetails').value,
                userType: 'subscriber',
            });
            if (resultUser.result) {
                console.log('token set');
                localStorage.setItem('token', resultUser.data);
                const resultReturn = { result: true, notice: resultUser.message };
                setUserExists(true);
                console.log('resultReturn Register success', resultReturn);
                return resultReturn;
            } else {
                const resultReturn = { result: false, notice: resultUser.message };
                console.log('resultReturn Register error', resultReturn);
                return resultReturn;
            }
        }
    };
    const updateRabanim = () => {
        const address = document.getElementById('rabbanim-address').value;
        const name = document.getElementById('rabbanim-name').value;
        const phone = document.getElementById('rabbanim-phone').value;
        setRabbanim([{ address: ' + address + ', phone: ' + phone + ', name: ' + name + ' }]);
    };

    React.useEffect(() => {
        getUserDetails(); // 
    }, []);

    React.useEffect(() => {
        if (isFormTouched) {
            validateForm(['id-photo'], null, iDPhoto); //
        }
    }, [iDPhoto]);

    return (
        <>
            <Helmet>
                <title>World of Tzedaka - Main</title>
            </Helmet>
            <main className="main campaign-sign-up-page">
                {openTermsPopup ? (<TermsPopup updateTermsPopup={showTermsPopup} />) : ''}
                <div className="main__body bg-color">
                    <div className="container">
                        <div className="login-page">
                            <h1 style={{ lineHeight: '0', marginBottom: '0' }} className="login-page__title _anim-items _fadeScale" data-animate-delay="02">
                                <span className="f-normal rubik weight-600 f-54 color-1">Become a Member</span>
                            </h1>
                            <p style={{ marginTop: 30, marginBottom: '0' }} className="center-text f-16 rubik f-normal weight-600 color-5">Main {'>>'} <span className="color-1">Become a Member</span></p>

                            <div className="login-form">
                                <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                                    <div className="color-1 roboto f-normal f-24 weight-500" style={{ marginBottom: 15 }}>Account Information:</div>
                                    <div className="form-grid">
                                        <div className="form-grid__item col-12">
                                            <div className="form-field  form-insel" onClick={showExistingUserNotice}>
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={EmailIcon} alt="" />
                                                    <input placeholder="E-Mail" className="border-none input color-4 weight-400 f-16 roboto f-normal" type="text" disabled={userExists} onChange={() => validateForm(['email'])} id="email" value={userInfo?.email} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                    <img src={PassIcon} alt="" />
                                                    <input placeholder="Password" className="border-none input color-4 weight-400 f-16 roboto f-normal" type="password" onChange={() => validateForm(['password'])} id="password" />
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="form-grid__item col-6 ">
                                            <div className="form-field form-insel">
                                                <label className="form-insel__legend">Re Password <span className="star-t">*</span></label>
                                                <input type="password" className="form-insel__input" />
                                            </div>
                                        </div> */}
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={PassIcon} alt="" />
                                                    <input placeholder="Re Password" className="border-none input color-4 weight-400 f-16 roboto f-normal" type="password" onChange={() => validateForm(['password'])} id="password" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                                    <div className="color-1 weight-500 roboto f-normal f-24" style={{ marginBottom: 15 }}>Personal Details:</div>

                                    <div className="form-grid">
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={UserIcon} alt="" />
                                                <input placeholder="First Name" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" onChange={() => validateForm(['first-name'])} id="first-name" value={userInfo?.firstName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={UserIcon} alt="" />
                                                    <input placeholder="Last Name" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" onChange={() => validateForm(['last-name'])} id="last-name" value={userInfo?.secondName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={PhoneIcon} alt="" />
                                                    <input placeholder="Phone Number" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" onChange={() => validateForm(['phone'])} id="phone" value={userInfo?.phoneNumber} />
                                                </div>
                                            </div>
                                        </div>
                                        {/*  <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <label className="form-insel__legend">Birth <span className="star-t">*</span></label>
                                                <input type="text" className="form-insel__input" placeholder="dd/mm/yyyy" />
                                            </div>
                                        </div> */}
                                    </div>
                                </div>

                                <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                                    <div className="color-1 weight-500 roboto f-normal f-24" style={{ marginBottom: 15 }}>Address:</div>
                                    <div className="form-grid">
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={StreetIcon} alt="" />
                                                    <input placeholder="Street" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id="address" value={userInfo?.address} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={CityIcon} alt="" />
                                                    <input placeholder="City / Area" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id="city" value={userInfo?.city} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                                    <div className="color-1 weight-500 roboto f-normal f-24" style={{ marginBottom: 15, marginTop: 20 }}>Campaign Details:</div>
                                    <div className="form-grid">
                                        <div className="form-grid__item col-12">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={HornIcon} alt="" />
                                                    <input placeholder="Name of organization / campagin / cause" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id="campaignName" value={userInfo?.campaignName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-grid__item col-12">
                                            <div className="form-field  form-insel">
                                                <div className="bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                    <p className="mb-0 f-16 color-4 roboto f-normal">Details</p>
                                                    <textarea style={{ marginTop: 10 }} type="text" id="campaignDetails" value={userInfo?.campaignDetails} placeholder="(Please enter description of cause, and the organization size/location (if applicable). Please elaborate.)" className="border-none input weight-400 f-10 f-normal roboto color-6" />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                                    <div className="color-1 weight-500 roboto f-normal f-24" style={{ marginTop: 22 }}>Vaad Hatzedaka Certificate:</div>
                                    <p className="weight-400 roboto f-normal color-5 f-18">Rabbonim who can serve as a reference for this cause:</p>
                                    {rabbanim?.map((item, index) => (
                                        <div className="form-grid form-with-plus relative">
                                            <div className="form-grid__item col-4">
                                                <div className="form-field  form-insel">
                                                    <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                    <img src={UserIcon} alt="" />
                                                        <input placeholder="Name" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id={'rabbanim-name-' + index} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-grid__item col-4">
                                                <div className="form-field  form-insel">
                                                    <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                    <img src={PhoneIcon} alt="" />
                                                        <input placeholder="Phone" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id={'rabbanim-phone-' + index} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-grid__item plusminus col-4">
                                                <div className="form-field  form-insel">
                                                    <div className="flex align-center bg-white" style={{ width: '100%', padding: 15, borderRadius: '10px' }}>
                                                    <img src={LocationOnIcon} alt="" />
                                                        <input placeholder="Address" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id={'rabbanim-address-' + index} />
                                                    </div>
                                                   
                                                </div>
                                               
                                            </div>
                                            <a onClick={addRabanimRow} style={{ marginLeft: '5px', marginTop: '15px' }}><img src={PlusIcon} alt="" /></a>
                                            {
                                                index !== 0 && (
                                                    <a onClick={() => subtractRabanimRow(index)} style={{ marginLeft: '5px', marginTop: '15px' }}><img src={MinusIcon} alt="" /></a>
                                                )
                                            }
                                        </div>
                                    ))}

                                </div>
                                <div className="_anim-items _fadeUp" data-animate-delay="02">
                                    <div className="form-grid form-with-plus relative">
                                        <div className="form-grid__item col-6">
                                            <div className="form-field" id="id-photo">
                                                <label className="form-legend color-1 weight-500 roboto f-24">Your ID: </label>
                                                <UploadImage setImage={setIDPhoto} btnName="Attach File" inputID="id-photo-input" />
                                            </div>
                                            {iDPhoto !== null ? (
                                                <div className="don-wrap__rad" style={{ background: 'url(' + config.imageUrl + iDPhoto + ') center center / cover no-repeat', minHeight: '200px' }}>
                                                </div>
                                            ) : ''}
                                        </div>
                                        <div className="form-grid__item col-6">
                                            <div className="form-field" id="id-photo">
                                                <label className="form-legend color-1 weight-500 roboto f-22">Profile Picture: <span className="color-1 weight-300 roboto">(optional)</span> </label>
                                                <UploadImage setImage={setAttachFile} btnName="Upload Photo" inputID="attach-file-input" />
                                                {attachFile !== null ? (
                                                    <div>
                                                        <b>Upploaded</b>&nbsp;
                                                        <a target="_blank" rel="noreferrer" href={config.imageUrl + attachFile}>Check it</a>
                                                    </div>
                                                ) : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                                    <p className="mb-0 roboto weight-600 f-24 color-5">
                                        Do you already have a certificate from Vaad Hatzedaka of Lakewood?
                                    </p>
                                    <div className="don-wrap__rad">
                                        <label className="radio" onClick={() => updateCertificateState(true)}>
                                            <input type="radio" name="certificate-state" id="certificate-state-true" />
                                            <span className="radio__text">
                                                <span className="weight-400 roboto color-5 f-16">If yes, please enter certificate number</span>
                                                {certificateState ? (
                                                    <div className="form-field  form-insel">
                                                        <label className="form-insel__legend"></label>
                                                        <input type="text" className="input-2" id="hatzedakaCertificateNumber" value={userInfo?.hatzedakaCertificateNumber} />
                                                    </div>
                                                ) : ''}
                                            </span>
                                        </label>
                                        <label className="radio" onClick={() => updateCertificateState(false)}>
                                            <input type="radio" value="true" name="certificate-state" id="certificate-state-false" />
                                            <span className="radio__text">
                                                <span className="weight-400 roboto color-5 f-16">
                                                    If not, your cause must be reviewed by the Vaad Hatzedaka of Lakewood to obtain a certificate.
                                                </span>
                                            </span>
                                        </label>
                                    </div>

                                </div>
                                {openVaadAgree ? (
                                    <div className="form-section">
                                        <div className="form-field">
                                            <label className="checkbox">
                                                <input type="checkbox" id="vaad-hatzedaka-payment" />
                                                <span className="checkbox__text">
                                                    I agree to pay $50 to the Vaad Hatzedaka of Lakewood if a certificate is granted.
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                ) : ''}
                                <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                                    <span className="color-1 weight-600 rubik f-normal f-18">Membership Fee:</span> <span className="rubik weight-400 f-16 f-normal color-5">The cost of using the World Of Tzedaka platform is</span> <span style={{ color: 'red' }} className="f-16">$28/mo.</span>
                                    <BanquestCreditCard doValidate={updateSubscription} showTermsPopup={showTermsPopup} paymentMode="campaign-subscription" amount={amount} invoiceNumber={subscriptionID} returnUrl="thank-you/subscribe/28/$" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
